import { Component, DestroyRef, ElementRef, inject, OnInit, signal, viewChild, WritableSignal } from '@angular/core';
import { environment } from '../../../environments/environment';
import { IS_MOBILE } from 'src/app/services/isMobile';
import { debounceTime, filter, fromEvent, Subscription } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent implements OnInit {
  assetPath = environment.assetPath;
  currentYear: number;
  isMobile = inject(IS_MOBILE);
  isSmallScreen: WritableSignal<boolean> = signal(false);
  windowHeight:number;

  mainContainerElement = viewChild<ElementRef<any>>('mainContainer');
  privacyTextElement = viewChild<ElementRef<any>>('privacyText');
  
  onResizeSubscription: Subscription;

  constructor() { }
  
  destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.currentYear = new Date().getFullYear();
    this.windowHeight = window.innerHeight;
  }
  ngAfterViewInit() {
    this.checkIsSmallScreen(this.windowHeight);

    const onResize$ = fromEvent(window, 'resize').pipe(
      debounceTime(500),
      filter(() => !this.isMobile()),
      takeUntilDestroyed(this.destroyRef)

    );
    this.onResizeSubscription = onResize$.subscribe( val => {
      const screenSize = val.target['innerHeight'];
      this.checkIsSmallScreen(screenSize);
    });
  }

  checkIsSmallScreen(screenSize){
    const mainContainerHeight = this.mainContainerElement()?.nativeElement?.offsetHeight;
    const privacyTextHeight = this.privacyTextElement()?.nativeElement?.offsetHeight;
    if(!mainContainerHeight || !privacyTextHeight){
      return;
    }
    if(screenSize < (mainContainerHeight + privacyTextHeight + 160)){
      this.isSmallScreen.set(true);
    }
    else{
      this.isSmallScreen.set(false);
    }
  }

  ngOnDestroy(){
    this.onResizeSubscription?.unsubscribe();
  }
}
